<p>offer-included-items-tab works!</p>
